import styles from './SystemOverviewPage.module.css';

export function SystemOverviewPage() {
  return (
    <div className={styles.page} id="top">
      {/* Header */}
      <header className={styles.header}>
        <h1 className={styles.logo}>
          CRM<span className={styles.logoAccent}>Clinica</span>
        </h1>
        <p className={styles.headerSub}>
          Plataforma SaaS B2B2C de agendamento clinico com orquestracao de campanhas
        </p>
      </header>

      {/* Table of Contents */}
      <nav className={styles.toc}>
        <h2>Indice</h2>
        <ul className={styles.tocList}>
          <li><a href="#visao-geral">1. Visao Geral do Sistema</a></li>
          <li><a href="#arquitetura">2. Arquitetura</a></li>
          <li><a href="#perfis">3. Perfis de Acesso</a></li>
          <li><a href="#login">4. Autenticacao</a></li>
          <li><a href="#dashboard">5. Dashboard Administrativo</a></li>
          <li><a href="#agenda">6. Agenda / Calendario</a></li>
          <li><a href="#painel-dia">7. Painel do Dia</a></li>
          <li><a href="#estado-consulta">8. Maquina de Estados da Consulta</a></li>
          <li><a href="#pacientes">9. Gestao de Pacientes</a></li>
          <li><a href="#recursos">10. Recursos (Medicos, Salas, Equipamentos)</a></li>
          <li><a href="#procedimentos">11. Tipos de Procedimento</a></li>
          <li><a href="#campanhas">12. Campanhas e Pacotes</a></li>
          <li><a href="#jornadas">13. Jornadas do Paciente</a></li>
          <li><a href="#politicas">14. Politicas e Regras de Negocio</a></li>
          <li><a href="#leads">15. Gestao de Leads</a></li>
          <li><a href="#convites">16. Convites</a></li>
          <li><a href="#widget">17. Widget de Campanha</a></li>
          <li><a href="#portal">18. Portal do Paciente</a></li>
          <li><a href="#usuarios">19. Gestao de Usuarios</a></li>
          <li><a href="#integracoes">20. Integracoes</a></li>
          <li><a href="#fluxos">21. Fluxos Completos</a></li>
          <li><a href="#patient-score">22. Score do Paciente</a></li>
          <li><a href="#lead-imports">23. Importacao e Qualificacao de Leads</a></li>
        </ul>
      </nav>

      {/* 1. Visao Geral */}
      <section className={styles.section} id="visao-geral">
        <h2>1. Visao Geral do Sistema</h2>
        <p>
          O CRMClinica e uma plataforma SaaS multi-tenant para gestao de clinicas medicas.
          Ele permite agendar consultas e exames, gerenciar pacientes, criar campanhas de marketing
          com pacotes de procedimentos, acompanhar jornadas de pacientes e capturar leads.
        </p>
        <div className={styles.grid3}>
          <div className={styles.card}>
            <div className={styles.cardTitle}>Agendamento</div>
            <p>Calendario visual por recurso, painel do dia em tempo real, maquina de estados completa.</p>
          </div>
          <div className={styles.card}>
            <div className={styles.cardTitle}>Campanhas</div>
            <p>Campanhas de marketing com pacotes de procedimentos, jornadas do paciente e widget embarcavel.</p>
          </div>
          <div className={styles.card}>
            <div className={styles.cardTitle}>Portal do Paciente</div>
            <p>Auto-agendamento, acompanhamento de jornada, historico de consultas.</p>
          </div>
        </div>
      </section>

      {/* 2. Arquitetura */}
      <section className={styles.section} id="arquitetura">
        <h2>2. Arquitetura</h2>
        <div className={styles.grid2}>
          <div className={styles.card}>
            <div className={styles.cardTitle}>Backend</div>
            <p>.NET 8 (ASP.NET Core) com Clean Architecture. Dapper + PostgreSQL (Supabase). JWT com refresh token rotation. Multi-tenant via tenant_id por linha.</p>
          </div>
          <div className={styles.card}>
            <div className={styles.cardTitle}>Frontend</div>
            <p>React 19 + TypeScript + Vite. TanStack Query para estado do servidor. CSS Modules. Axios com interceptor JWT.</p>
          </div>
        </div>
        <div className={styles.infoBox}>
          Multi-tenancy: cada registro no banco possui um <code>tenant_id</code>. A filtragem e feita na camada de repositorio, garantindo isolamento entre clinicas.
        </div>
      </section>

      {/* 3. Perfis de Acesso */}
      <section className={styles.section} id="perfis">
        <h2>3. Perfis de Acesso</h2>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Perfil</th>
              <th>Acesso</th>
              <th>Descricao</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><span className={`${styles.badge} ${styles.roleAdmin}`}>Admin</span></td>
              <td>Todas as telas</td>
              <td>Acesso total: gestao de usuarios, politicas, integracoes e todas as telas operacionais.</td>
            </tr>
            <tr>
              <td><span className={`${styles.badge} ${styles.roleReceptionist}`}>Recepcionista</span></td>
              <td>Telas operacionais</td>
              <td>Dashboard, agenda, painel do dia, pacientes, campanhas, leads, convites. Sem acesso a usuarios, politicas ou integracoes.</td>
            </tr>
            <tr>
              <td><span className={`${styles.badge} ${styles.rolePatient}`}>Paciente</span></td>
              <td>Portal do paciente</td>
              <td>Auto-agendamento, acompanhamento de jornada, historico pessoal. Se tentar acessar /admin, e redirecionado para o portal.</td>
            </tr>
          </tbody>
        </table>
      </section>

      {/* 4. Autenticacao */}
      <section className={styles.section} id="login">
        <h2>4. Autenticacao</h2>

        <h3>Login <span className={styles.route}>/login</span></h3>
        <p>
          O usuario informa email e senha. O sistema valida as credenciais e retorna um par de tokens JWT (access + refresh).
          Os tokens sao armazenados em memoria (nao no localStorage, por seguranca). Apos login, o redirecionamento depende do perfil:
        </p>
        <ul>
          <li><strong>Admin/Recepcionista:</strong> vai para <code>/admin/dashboard</code></li>
          <li><strong>Paciente:</strong> vai para <code>/portal/dashboard</code></li>
        </ul>

        <h3>Cadastro <span className={styles.route}>/register</span></h3>
        <p>
          Formulario com nome, email, senha e confirmacao de senha. Ha um indicador de forca da senha (fraca/media/forte).
          Apos cadastro, redireciona para o login.
        </p>

        <h3>Recuperacao de Senha <span className={styles.route}>/forgot-password</span></h3>
        <p>
          O usuario informa o email e recebe instrucoes para redefinir a senha. A tela muda para um estado de confirmacao apos envio.
        </p>

        <div className={styles.infoBox}>
          A sessao e restaurada automaticamente: ao recarregar a pagina, o sistema tenta recuperar a sessao via <code>GET /auth/me</code> se houver token em memoria.
        </div>
      </section>

      {/* 5. Dashboard */}
      <section className={styles.section} id="dashboard">
        <h2>5. Dashboard Administrativo <span className={styles.route}>/admin/dashboard</span></h2>
        <p>Tela inicial apos login para Admin e Recepcionista. Mostra o resumo do dia atual.</p>

        <h3>Cards de Resumo</h3>
        <div className={styles.grid2}>
          <div className={styles.card}>
            <div className={styles.cardTitle}>Consultas Hoje</div>
            <p>Total de agendamentos para o dia atual (todos os status).</p>
          </div>
          <div className={styles.card}>
            <div className={styles.cardTitle}>Pacientes Cadastrados</div>
            <p>Total geral de pacientes no sistema.</p>
          </div>
          <div className={styles.card}>
            <div className={styles.cardTitle}>Campanhas Ativas</div>
            <p>Quantidade de campanhas com status ACTIVE.</p>
          </div>
          <div className={styles.card}>
            <div className={styles.cardTitle}>Aguardando Atendimento</div>
            <p>Consultas com status WAITING (paciente ja fez check-in e aguarda ser chamado).</p>
          </div>
        </div>

        <h3>Acoes Rapidas</h3>
        <p>Botoes de atalho para: Novo Agendamento, Novo Paciente e Painel do Dia.</p>

        <h3>Atividade Recente</h3>
        <p>Lista das ultimas 10 consultas do dia, ordenadas por horario (mais recente primeiro), mostrando paciente, procedimento, horario e status com cor.</p>
      </section>

      {/* 6. Agenda */}
      <section className={styles.section} id="agenda">
        <h2>6. Agenda / Calendario <span className={styles.route}>/admin/schedule</span></h2>
        <p>Visao de calendario diario com timeline visual de 07:00 as 20:00.</p>

        <h3>Visualizacao</h3>
        <ul>
          <li><strong>Multiplos recursos em colunas:</strong> quando nenhum filtro esta ativo, todos os recursos aparecem lado a lado como colunas na timeline.</li>
          <li><strong>Blocos coloridos:</strong> cada consulta e posicionada pelo horario de inicio/fim, com cor do status.</li>
          <li><strong>Indicador de hora atual:</strong> linha vermelha que marca o horario corrente (atualiza a cada 60 segundos, aparece apenas para o dia de hoje).</li>
          <li><strong>Navegacao de data:</strong> botoes anterior/proximo, botao "Hoje", campo de data.</li>
          <li><strong>Filtro por recurso:</strong> dropdown para focar em um unico recurso.</li>
        </ul>

        <h3>Acoes</h3>
        <ul>
          <li><strong>Clicar em consulta:</strong> abre modal com detalhes + botoes de transicao de estado.</li>
          <li><strong>"Novo Agendamento":</strong> abre wizard para criar nova consulta (selecionar paciente, recurso, procedimento, data e horario).</li>
          <li><strong>Cancelamento:</strong> modal separado que exige motivo obrigatorio.</li>
        </ul>

        <h3>Cards de Status no Topo</h3>
        <p>Total, Agendados, Confirmados, Aguardando, Em Atendimento e Concluidos para o dia selecionado.</p>
      </section>

      {/* 7. Painel do Dia */}
      <section className={styles.section} id="painel-dia">
        <h2>7. Painel do Dia <span className={styles.route}>/admin/daily-panel</span></h2>
        <p>Visao operacional em tempo real das consultas de hoje. Ideal para a recepcao da clinica.</p>

        <div className={styles.warningBox}>
          O painel atualiza automaticamente a cada 30 segundos via polling. Tambem ha botao manual "Atualizar".
        </div>

        <h3>Funcionamento</h3>
        <ul>
          <li><strong>Lista ordenada por horario:</strong> todas as consultas do dia, com horario, paciente, procedimento, recurso e status.</li>
          <li><strong>Botoes de acao inline:</strong> cada linha mostra os botoes de transicao permitidos pelo estado atual da consulta (ex: "Confirmar", "Check-in", "Iniciar", "Concluir").</li>
          <li><strong>Filtro por recurso:</strong> para focar em um unico medico/sala.</li>
          <li><strong>4 cards no topo:</strong> Agendados, Confirmados, Concluidos, Nao Compareceram.</li>
        </ul>
      </section>

      {/* 8. Maquina de Estados */}
      <section className={styles.section} id="estado-consulta">
        <h2>8. Maquina de Estados da Consulta</h2>
        <p>Cada consulta segue um fluxo rigido de estados. As transicoes sao controladas e so permitem avancos validos.</p>

        <div className={styles.stateMachine}>
          <h3>Fluxo Principal</h3>
          <div className={styles.stateFlow}>
            <span className={styles.stateNode} style={{ backgroundColor: '#4A90D9' }}>AGENDADO</span>
            <span className={styles.stateArrow}>&rarr;</span>
            <span className={styles.stateNode} style={{ backgroundColor: '#00A651' }}>CONFIRMADO</span>
            <span className={styles.stateArrow}>&rarr;</span>
            <span className={styles.stateNode} style={{ backgroundColor: '#F7941D' }}>AGUARDANDO</span>
            <span className={styles.stateArrow}>&rarr;</span>
            <span className={styles.stateNode} style={{ backgroundColor: '#7B61FF' }}>EM ATENDIMENTO</span>
            <span className={styles.stateArrow}>&rarr;</span>
            <span className={styles.stateNode} style={{ backgroundColor: '#6B7280' }}>CONCLUIDO</span>
          </div>

          <h3>Saidas Alternativas</h3>
          <div className={styles.stateFlow}>
            <span className={styles.stateNode} style={{ backgroundColor: '#4A90D9' }}>AGENDADO / CONFIRMADO</span>
            <span className={styles.stateArrow}>&rarr;</span>
            <span className={styles.stateNode} style={{ backgroundColor: '#DC2626' }}>CANCELADO</span>
          </div>
          <div className={styles.stateFlow}>
            <span className={styles.stateNode} style={{ backgroundColor: '#F7941D' }}>AGUARDANDO</span>
            <span className={styles.stateArrow}>&rarr;</span>
            <span className={styles.stateNode} style={{ backgroundColor: '#DC2626' }}>NAO COMPARECEU</span>
          </div>
        </div>

        <table className={styles.table}>
          <thead>
            <tr>
              <th>Status</th>
              <th>Significado</th>
              <th>Acoes Permitidas</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><span className={`${styles.badge} ${styles.badgeBlue}`}>Agendado</span></td>
              <td>Consulta criada, aguardando confirmacao</td>
              <td>Confirmar, Cancelar</td>
            </tr>
            <tr>
              <td><span className={`${styles.badge} ${styles.badgeGreen}`}>Confirmado</span></td>
              <td>Paciente confirmou presenca</td>
              <td>Check-in (paciente chegou), Cancelar</td>
            </tr>
            <tr>
              <td><span className={`${styles.badge} ${styles.badgeOrange}`}>Aguardando</span></td>
              <td>Paciente na sala de espera</td>
              <td>Iniciar Atendimento, Marcar Nao Compareceu</td>
            </tr>
            <tr>
              <td><span className={`${styles.badge} ${styles.badgePurple}`}>Em Atendimento</span></td>
              <td>Consulta em andamento</td>
              <td>Concluir</td>
            </tr>
            <tr>
              <td><span className={`${styles.badge} ${styles.badgeGray}`}>Concluido</span></td>
              <td>Consulta finalizada (estado terminal)</td>
              <td>Nenhuma</td>
            </tr>
            <tr>
              <td><span className={`${styles.badge} ${styles.badgeRed}`}>Cancelado</span></td>
              <td>Consulta cancelada (requer motivo obrigatorio)</td>
              <td>Nenhuma</td>
            </tr>
            <tr>
              <td><span className={`${styles.badge} ${styles.badgeRed}`}>Nao Compareceu</span></td>
              <td>Paciente fez check-in mas nao foi atendido</td>
              <td>Nenhuma</td>
            </tr>
          </tbody>
        </table>
      </section>

      {/* 9. Pacientes */}
      <section className={styles.section} id="pacientes">
        <h2>9. Gestao de Pacientes <span className={styles.route}>/admin/patients</span></h2>
        <p>Cadastro completo de pacientes com busca, paginacao e CRUD.</p>

        <h3>Campos do Paciente</h3>
        <table className={styles.table}>
          <thead>
            <tr><th>Campo</th><th>Obrigatorio</th><th>Descricao</th></tr>
          </thead>
          <tbody>
            <tr><td>Nome</td><td>Sim</td><td>Nome completo</td></tr>
            <tr><td>CPF</td><td>Sim</td><td>11 digitos, com validacao</td></tr>
            <tr><td>Telefone</td><td>Sim</td><td>Com mascara</td></tr>
            <tr><td>Email</td><td>Nao</td><td>Email de contato</td></tr>
            <tr><td>Data de Nascimento</td><td>Nao</td><td>Formato brasileiro</td></tr>
            <tr><td>Convenio</td><td>Nao</td><td>Nome e numero do plano de saude</td></tr>
            <tr><td>Observacoes</td><td>Nao</td><td>Notas clinicas (alergias, condicoes, etc.)</td></tr>
          </tbody>
        </table>

        <h3>Funcionalidades</h3>
        <ul>
          <li>Busca por nome, CPF ou telefone (com debounce de 300ms)</li>
          <li>Tabela paginada (10 por pagina)</li>
          <li>Criar, editar, visualizar detalhes e ativar/desativar pacientes</li>
        </ul>
      </section>

      {/* 10. Recursos */}
      <section className={styles.section} id="recursos">
        <h2>10. Recursos <span className={styles.route}>/admin/resources</span></h2>
        <p>Recursos sao as entidades que possuem agenda: medicos, salas e equipamentos.</p>

        <h3>Tipos de Recurso</h3>
        <div className={styles.grid3}>
          <div className={styles.card}>
            <div className={styles.cardTitle}>Medico</div>
            <p>Profissional que atende. Possui agenda semanal e procedimentos vinculados.</p>
          </div>
          <div className={styles.card}>
            <div className={styles.cardTitle}>Sala</div>
            <p>Sala de exames ou atendimento. Ex: Sala de Exames 1.</p>
          </div>
          <div className={styles.card}>
            <div className={styles.cardTitle}>Equipamento</div>
            <p>Aparelhos medicos com agenda propria. Ex: Aparelho de Raio-X.</p>
          </div>
        </div>

        <h3>Detalhe do Recurso <span className={styles.route}>/admin/resources/:id</span></h3>
        <p>Cada recurso possui 3 secoes de configuracao:</p>
        <ul>
          <li><strong>Grade Semanal:</strong> horarios de funcionamento por dia da semana (seg-dom), com duracao do slot em minutos.</li>
          <li><strong>Excecoes:</strong> bloqueios por data especifica. Tipos: Bloqueio Total (feriado), Bloqueio Parcial (congresso a tarde), Horario Especial (plantao).</li>
          <li><strong>Procedimentos Vinculados:</strong> quais procedimentos aquele recurso pode realizar. Um medico cardiologista tera "Consulta Cardiologia" e "ECG" vinculados.</li>
        </ul>
      </section>

      {/* 11. Procedimentos */}
      <section className={styles.section} id="procedimentos">
        <h2>11. Tipos de Procedimento <span className={styles.route}>/admin/procedure-types</span></h2>
        <p>Catalogo de todos os procedimentos oferecidos pela clinica.</p>

        <h3>Campos</h3>
        <table className={styles.table}>
          <thead>
            <tr><th>Campo</th><th>Descricao</th></tr>
          </thead>
          <tbody>
            <tr><td>Nome</td><td>Ex: "Consulta Cardiologia", "Ultrassonografia Abdominal"</td></tr>
            <tr><td>Duracao (minutos)</td><td>Tempo padrao do procedimento (5 a 480 min)</td></tr>
            <tr><td>Requer Preparo</td><td>Se sim, exibe instrucoes de preparo ao paciente</td></tr>
            <tr><td>Instrucoes de Preparo</td><td>Ex: "Jejum de 6 horas. Beber 4 copos de agua 1h antes."</td></tr>
          </tbody>
        </table>
      </section>

      {/* 12. Campanhas */}
      <section className={styles.section} id="campanhas">
        <h2>12. Campanhas e Pacotes <span className={styles.route}>/admin/campaigns</span></h2>
        <p>
          Campanhas sao acoes de marketing que agrupam pacotes de procedimentos.
          Cada campanha possui um slug unico que gera um widget embarcavel para captura de leads.
        </p>

        <h3>Estados da Campanha</h3>
        <div className={styles.stateMachine}>
          <div className={styles.stateFlow}>
            <span className={styles.stateNode} style={{ backgroundColor: '#6B7280' }}>RASCUNHO</span>
            <span className={styles.stateArrow}>&rarr;</span>
            <span className={styles.stateNode} style={{ backgroundColor: '#00A651' }}>ATIVA</span>
            <span className={styles.stateArrow}>&harr;</span>
            <span className={styles.stateNode} style={{ backgroundColor: '#F7941D' }}>PAUSADA</span>
            <span className={styles.stateArrow}>&rarr;</span>
            <span className={styles.stateNode} style={{ backgroundColor: '#4A90D9' }}>FINALIZADA</span>
          </div>
        </div>

        <h3>Detalhe da Campanha <span className={styles.route}>/admin/campaigns/:id</span></h3>
        <p>Duas abas:</p>
        <ul>
          <li><strong>Pacotes:</strong> cada pacote tem nome, descricao, preco e uma lista ordenada de procedimentos (PackageItems) com quantidade. Ex: "Check-up Premium" = Consulta Geral + Hemograma + ECG + Ultrassonografia por R$350.</li>
          <li><strong>Inscricoes:</strong> tabela dos pacientes inscritos, mostrando pacote, data de inscricao, progresso (X/Y etapas) e status da jornada.</li>
        </ul>

        <div className={styles.infoBox}>
          O botao "Copiar link da campanha" gera a URL do widget (<code>/widget/campaign/:slug</code>) para compartilhar em redes sociais ou embedar em sites.
        </div>
      </section>

      {/* 13. Jornadas */}
      <section className={styles.section} id="jornadas">
        <h2>13. Jornadas do Paciente <span className={styles.route}>/admin/patient-journeys/:id</span></h2>
        <p>
          Quando um paciente se inscreve em um pacote de campanha, e criada uma Jornada.
          A jornada e uma lista ordenada de etapas (JourneySteps), uma para cada item do pacote.
        </p>

        <h3>Hierarquia</h3>
        <div className={styles.flowBox}>
          <strong>Campanha</strong> &rarr; <strong>Pacote</strong> &rarr; <strong>Items do Pacote</strong><br />
          <strong>Paciente</strong> se inscreve &rarr; <strong>Jornada</strong> &rarr; <strong>Etapas da Jornada</strong> (1 por item)
        </div>

        <h3>Status das Etapas</h3>
        <table className={styles.table}>
          <thead>
            <tr><th>Status</th><th>Significado</th></tr>
          </thead>
          <tbody>
            <tr><td><span className={`${styles.badge} ${styles.badgeGray}`}>Pendente</span></td><td>Etapa ainda nao agendada</td></tr>
            <tr><td><span className={`${styles.badge} ${styles.badgeBlue}`}>Agendada</span></td><td>Consulta ja criada para esta etapa</td></tr>
            <tr><td><span className={`${styles.badge} ${styles.badgeGreen}`}>Concluida</span></td><td>Consulta realizada com sucesso</td></tr>
            <tr><td><span className={`${styles.badge} ${styles.badgeOrange}`}>Ignorada</span></td><td>Etapa pulada por decisao medica/paciente</td></tr>
          </tbody>
        </table>

        <h3>Politicas na Jornada</h3>
        <p>
          Ao visualizar a jornada, o sistema avalia as politicas ativas e exibe avisos em laranja caso alguma etapa esteja bloqueada.
          Ex: "E necessario completar Consulta Cardiologia antes de realizar Holter 24h" (politica PREREQUISITE).
        </p>
      </section>

      {/* 14. Politicas */}
      <section className={styles.section} id="politicas">
        <h2>14. Politicas e Regras de Negocio <span className={styles.route}>/admin/policies</span></h2>
        <p>
          Politicas sao regras configuráveis que controlam o agendamento. Sao avaliadas pelo backend ao determinar as proximas etapas de uma jornada. Somente o perfil Admin pode gerenciar politicas.
        </p>

        <table className={styles.table}>
          <thead>
            <tr><th>Tipo</th><th>Descricao</th><th>Exemplo</th></tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>RESCHEDULE_WINDOW</strong></td>
              <td>Define janela de remarcacao em dias (min e max)</td>
              <td>Min: 2 dias, Max: 30 dias de antecedencia</td>
            </tr>
            <tr>
              <td><strong>PREREQUISITE</strong></td>
              <td>Exige um procedimento antes de outro</td>
              <td>Consulta Cardiologia obrigatoria antes de Holter</td>
            </tr>
            <tr>
              <td><strong>MIN_INTERVAL</strong></td>
              <td>Intervalo minimo de horas entre procedimentos</td>
              <td>24 horas entre consultas do mesmo paciente</td>
            </tr>
            <tr>
              <td><strong>MAX_INTERVAL</strong></td>
              <td>Prazo maximo de dias para completar procedimentos</td>
              <td>Check-up deve ser concluido em ate 90 dias</td>
            </tr>
          </tbody>
        </table>

        <div className={styles.infoBox}>
          Politicas podem ser <strong>Globais</strong> (aplicam a todas as campanhas) ou vinculadas a uma <strong>campanha especifica</strong>.
        </div>
      </section>

      {/* 15. Leads */}
      <section className={styles.section} id="leads">
        <h2>15. Gestao de Leads <span className={styles.route}>/admin/leads</span></h2>
        <p>
          Leads sao potenciais pacientes capturados pelo widget de campanha ou manualmente.
          O sistema registra a origem (UTM source, medium, campaign) para rastreamento de marketing.
        </p>

        <h3>Estados do Lead</h3>
        <div className={styles.stateMachine}>
          <div className={styles.stateFlow}>
            <span className={styles.stateNode} style={{ backgroundColor: '#4A90D9' }}>NOVO</span>
            <span className={styles.stateArrow}>&rarr;</span>
            <span className={styles.stateNode} style={{ backgroundColor: '#F7941D' }}>CONTATADO</span>
            <span className={styles.stateArrow}>&rarr;</span>
            <span className={styles.stateNode} style={{ backgroundColor: '#00A651' }}>CONVERTIDO</span>
          </div>
          <div className={styles.stateFlow}>
            <span className={styles.stateNode} style={{ backgroundColor: '#4A90D9' }}>NOVO / CONTATADO</span>
            <span className={styles.stateArrow}>&rarr;</span>
            <span className={styles.stateNode} style={{ backgroundColor: '#DC2626' }}>PERDIDO</span>
          </div>
        </div>

        <h3>Conversao de Lead</h3>
        <p>
          Ao clicar "Converter", o sistema cria automaticamente um convite (invitation) para o lead.
          O link do convite e exibido para copia e envio ao paciente potencial.
        </p>
      </section>

      {/* 16. Convites */}
      <section className={styles.section} id="convites">
        <h2>16. Convites <span className={styles.route}>/admin/invitations</span></h2>
        <p>
          Convites sao links unicos enviados a pacientes para que se cadastrem no sistema.
          Podem ser vinculados a uma campanha e pacote especificos.
        </p>

        <h3>Campos do Convite</h3>
        <ul>
          <li>Nome do paciente, CPF, telefone, email</li>
          <li>Campanha e pacote (opcionais)</li>
          <li>Dias para expirar (1 a 90, padrao 7)</li>
        </ul>

        <h3>Status</h3>
        <table className={styles.table}>
          <thead><tr><th>Status</th><th>Descricao</th></tr></thead>
          <tbody>
            <tr><td><span className={`${styles.badge} ${styles.badgeOrange}`}>Pendente</span></td><td>Link ativo, aguardando aceitacao</td></tr>
            <tr><td><span className={`${styles.badge} ${styles.badgeGreen}`}>Aceito</span></td><td>Paciente clicou no link e se cadastrou</td></tr>
            <tr><td><span className={`${styles.badge} ${styles.badgeGray}`}>Expirado</span></td><td>Prazo de validade esgotado</td></tr>
            <tr><td><span className={`${styles.badge} ${styles.badgeRed}`}>Cancelado</span></td><td>Convite cancelado pelo staff</td></tr>
          </tbody>
        </table>
      </section>

      {/* 17. Widget */}
      <section className={styles.section} id="widget">
        <h2>17. Widget de Campanha <span className={styles.route}>/widget/campaign/:slug</span></h2>
        <p>
          Pagina publica standalone (sem layout do admin) projetada para ser embarcada via iframe em sites externos.
          Serve como formulario de captura de leads para uma campanha especifica.
        </p>

        <h3>Funcionamento</h3>
        <div className={styles.flowBox}>
          <div className={styles.flowStep}>
            <span className={styles.flowNumber}>1</span>
            <div className={styles.flowContent}>
              <strong>Exibe a campanha</strong>
              <p>Nome, descricao, periodo de validade e lista de pacotes com precos.</p>
            </div>
          </div>
          <div className={styles.flowStep}>
            <span className={styles.flowNumber}>2</span>
            <div className={styles.flowContent}>
              <strong>Paciente seleciona pacotes de interesse</strong>
              <p>Cards clicaveis mostrando procedimentos e preco de cada pacote.</p>
            </div>
          </div>
          <div className={styles.flowStep}>
            <span className={styles.flowNumber}>3</span>
            <div className={styles.flowContent}>
              <strong>Preenche formulario de lead</strong>
              <p>Nome, telefone (obrigatorios), email e observacoes (opcionais).</p>
            </div>
          </div>
          <div className={styles.flowStep}>
            <span className={styles.flowNumber}>4</span>
            <div className={styles.flowContent}>
              <strong>Lead capturado com UTM</strong>
              <p>Os parametros utm_source, utm_medium e utm_campaign da URL sao salvos junto com o lead.</p>
            </div>
          </div>
        </div>
      </section>

      {/* 18. Portal */}
      <section className={styles.section} id="portal">
        <h2>18. Portal do Paciente</h2>

        <h3>Cadastro do Paciente <span className={styles.route}>/portal/register</span></h3>
        <p>
          Formulario mobile-first com branding da clinica. Campos: nome, CPF (com validacao de digitos verificadores), data de nascimento,
          email, senha, telefone e convenio. Apos cadastro, o paciente ja fica logado.
        </p>

        <h3>Aceitar Convite <span className={styles.route}>/portal/invite/:token</span></h3>
        <p>
          Quando o paciente clica no link de convite, o formulario ja vem pre-preenchido com os dados informados pelo staff.
          Apos aceitar, o paciente e automaticamente vinculado a campanha/pacote do convite.
        </p>

        <h3>Auto-Agendamento <span className={styles.route}>/portal/schedule</span></h3>
        <p>Wizard de 5 etapas para o paciente agendar suas consultas:</p>
        <div className={styles.flowBox}>
          <div className={styles.flowStep}>
            <span className={styles.flowNumber}>1</span>
            <div className={styles.flowContent}>
              <strong>Procedimento</strong>
              <p>Se o paciente tem uma jornada ativa, mostra as etapas pendentes. Apenas etapas com status PENDING sao selecionaveis.</p>
            </div>
          </div>
          <div className={styles.flowStep}>
            <span className={styles.flowNumber}>2</span>
            <div className={styles.flowContent}>
              <strong>Profissional</strong>
              <p>Lista de recursos (medicos) ativos que realizam o procedimento selecionado.</p>
            </div>
          </div>
          <div className={styles.flowStep}>
            <span className={styles.flowNumber}>3</span>
            <div className={styles.flowContent}>
              <strong>Data</strong>
              <p>Proximos 14 dias a partir de amanha. Cards com dia da semana e data formatada.</p>
            </div>
          </div>
          <div className={styles.flowStep}>
            <span className={styles.flowNumber}>4</span>
            <div className={styles.flowContent}>
              <strong>Horario</strong>
              <p>Slots disponiveis consultados via API. Grid de botoes de horario.</p>
            </div>
          </div>
          <div className={styles.flowStep}>
            <span className={styles.flowNumber}>5</span>
            <div className={styles.flowContent}>
              <strong>Confirmacao</strong>
              <p>Resumo de tudo selecionado + botao "Confirmar agendamento".</p>
            </div>
          </div>
        </div>

        <h3>Painel do Paciente <span className={styles.route}>/portal/dashboard</span></h3>
        <p>Dashboard pessoal do paciente com:</p>
        <ul>
          <li><strong>Jornada ativa:</strong> timeline visual com as etapas e seus status (completa, agendada, pendente).</li>
          <li><strong>Proximos agendamentos:</strong> cards com procedimento, recurso, data, horario e acoes (reagendar ou cancelar).</li>
          <li><strong>Historico:</strong> consultas passadas (somente leitura).</li>
        </ul>
      </section>

      {/* 19. Usuarios */}
      <section className={styles.section} id="usuarios">
        <h2>19. Gestao de Usuarios <span className={styles.route}>/admin/users</span></h2>
        <p>Somente Admin. Gerencia contas de acesso ao sistema (staff e pacientes).</p>
        <ul>
          <li>Criar usuario: nome, email, senha (min 8), CPF, telefone, roles (pelo menos 1)</li>
          <li>Editar usuario: alterar dados e roles (email nao editavel)</li>
          <li>Resetar senha: define nova senha manualmente</li>
          <li>Ativar/desativar contas</li>
        </ul>
      </section>

      {/* 20. Integracoes */}
      <section className={styles.section} id="integracoes">
        <h2>20. Integracoes <span className={styles.route}>/admin/integrations</span></h2>
        <p>Somente Admin. Monitora a fila de mensagens do padrao Outbox (integracao com sistemas externos como Korus/Pixeon).</p>

        <div className={styles.warningBox}>
          O painel atualiza automaticamente a cada 10 segundos. Exibe um indicador "Atualizado Xs atras".
        </div>

        <h3>Tipos de Mensagem</h3>
        <ul>
          <li><strong>PATIENT_SYNC:</strong> sincronizacao de pacientes</li>
          <li><strong>APPOINTMENT_SYNC:</strong> sincronizacao de agendamentos</li>
          <li><strong>SLOT_FETCH:</strong> busca de horarios</li>
          <li><strong>STATUS_SYNC:</strong> sincronizacao de status</li>
        </ul>

        <h3>Status da Fila</h3>
        <p>Pendentes, Processando, Concluidos, Falhas, Dead Letters. Mensagens com falha podem ser reenviadas. Dead letters podem ser reprocessadas.</p>
      </section>

      {/* 21. Fluxos */}
      <section className={styles.section} id="fluxos">
        <h2>21. Fluxos Completos</h2>

        <h3>Fluxo 1: Lead ate Paciente</h3>
        <div className={styles.flowBox}>
          <div className={styles.flowStep}>
            <span className={styles.flowNumber}>1</span>
            <div className={styles.flowContent}>
              <strong>Captura do Lead</strong>
              <p>Visitante preenche o widget da campanha. Lead criado como NOVO com dados de UTM.</p>
            </div>
          </div>
          <div className={styles.flowStep}>
            <span className={styles.flowNumber}>2</span>
            <div className={styles.flowContent}>
              <strong>Contato pelo Staff</strong>
              <p>Recepcionista marca lead como CONTATADO apos ligar/enviar WhatsApp.</p>
            </div>
          </div>
          <div className={styles.flowStep}>
            <span className={styles.flowNumber}>3</span>
            <div className={styles.flowContent}>
              <strong>Conversao</strong>
              <p>Staff clica "Converter" - sistema gera convite automaticamente com link unico.</p>
            </div>
          </div>
          <div className={styles.flowStep}>
            <span className={styles.flowNumber}>4</span>
            <div className={styles.flowContent}>
              <strong>Cadastro do Paciente</strong>
              <p>Paciente abre o link, preenche formulario pre-populado, cria conta.</p>
            </div>
          </div>
          <div className={styles.flowStep}>
            <span className={styles.flowNumber}>5</span>
            <div className={styles.flowContent}>
              <strong>Inicio da Jornada</strong>
              <p>Paciente e vinculado a campanha/pacote. Jornada criada com etapas pendentes.</p>
            </div>
          </div>
        </div>

        <h3>Fluxo 2: Dia a Dia da Clinica</h3>
        <div className={styles.flowBox}>
          <div className={styles.flowStep}>
            <span className={styles.flowNumber}>1</span>
            <div className={styles.flowContent}>
              <strong>Inicio do Dia</strong>
              <p>Recepcionista acessa o Dashboard para ver resumo e o Painel do Dia para gerenciar a fila.</p>
            </div>
          </div>
          <div className={styles.flowStep}>
            <span className={styles.flowNumber}>2</span>
            <div className={styles.flowContent}>
              <strong>Confirmacao</strong>
              <p>Consultas AGENDADAS sao confirmadas conforme pacientes respondem (WhatsApp/telefone).</p>
            </div>
          </div>
          <div className={styles.flowStep}>
            <span className={styles.flowNumber}>3</span>
            <div className={styles.flowContent}>
              <strong>Check-in</strong>
              <p>Quando o paciente chega, recepcionista clica "Check-in" — status muda para AGUARDANDO.</p>
            </div>
          </div>
          <div className={styles.flowStep}>
            <span className={styles.flowNumber}>4</span>
            <div className={styles.flowContent}>
              <strong>Atendimento</strong>
              <p>Medico inicia o atendimento — status muda para EM ATENDIMENTO.</p>
            </div>
          </div>
          <div className={styles.flowStep}>
            <span className={styles.flowNumber}>5</span>
            <div className={styles.flowContent}>
              <strong>Conclusao</strong>
              <p>Apos a consulta, medico/recepcionista marca como CONCLUIDO. Se parte de uma jornada, a etapa tambem e concluida.</p>
            </div>
          </div>
        </div>

        <h3>Fluxo 3: Auto-agendamento pelo Paciente</h3>
        <div className={styles.flowBox}>
          <div className={styles.flowStep}>
            <span className={styles.flowNumber}>1</span>
            <div className={styles.flowContent}>
              <strong>Acessa o Portal</strong>
              <p>Paciente faz login e ve seu dashboard com jornada ativa e proximas consultas.</p>
            </div>
          </div>
          <div className={styles.flowStep}>
            <span className={styles.flowNumber}>2</span>
            <div className={styles.flowContent}>
              <strong>Inicia Agendamento</strong>
              <p>Clica "Agendar procedimento" e entra no wizard de 5 etapas.</p>
            </div>
          </div>
          <div className={styles.flowStep}>
            <span className={styles.flowNumber}>3</span>
            <div className={styles.flowContent}>
              <strong>Selecao</strong>
              <p>Escolhe a etapa pendente da jornada, seleciona profissional, data e horario disponivel.</p>
            </div>
          </div>
          <div className={styles.flowStep}>
            <span className={styles.flowNumber}>4</span>
            <div className={styles.flowContent}>
              <strong>Confirmacao</strong>
              <p>Revisa e confirma. Consulta criada como AGENDADA e vinculada a etapa da jornada.</p>
            </div>
          </div>
        </div>
      </section>

      {/* 22. Score do Paciente */}
      <section className={styles.section} id="patient-score">
        <h2>22. Score do Paciente</h2>
        <p>
          Sistema de pontuacao de engajamento (0-100) que classifica pacientes automaticamente
          com base no historico de consultas, frequencia, confirmacoes e participacao em campanhas.
          Visivel na listagem de pacientes e em uma pagina dedicada com analytics.
        </p>

        <h3>Criterios de Pontuacao</h3>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Criterio</th>
              <th>Peso</th>
              <th>Calculo</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Taxa de Presenca</td>
              <td><strong>30 pts</strong></td>
              <td>(Consultas concluidas / total agendadas) x 30</td>
            </tr>
            <tr>
              <td>Frequencia de Visitas</td>
              <td><strong>25 pts</strong></td>
              <td>Meses com consulta nos ultimos 6 meses: (meses ativos / 6) x 25</td>
            </tr>
            <tr>
              <td>Recencia</td>
              <td><strong>20 pts</strong></td>
              <td>Dias desde a ultima consulta: 0-7d = 20, 8-30d = 16, 31-60d = 12, 61-90d = 8, 91-180d = 4, 180d+ = 0</td>
            </tr>
            <tr>
              <td>Tempo como Paciente</td>
              <td><strong>10 pts</strong></td>
              <td>Meses desde cadastro (cap 12): min(meses, 12) / 12 x 10</td>
            </tr>
            <tr>
              <td>Taxa de Confirmacao</td>
              <td><strong>10 pts</strong></td>
              <td>(Confirmados antes do dia / total agendadas) x 10</td>
            </tr>
            <tr>
              <td>Engajamento Campanhas</td>
              <td><strong>5 pts</strong></td>
              <td>Participou de campanha = 3pts, Completou jornada = +2pts</td>
            </tr>
          </tbody>
        </table>

        <h3>Classificacoes</h3>
        <div className={styles.grid3}>
          <div className={styles.card}>
            <div className={styles.cardTitle}>
              <span className={styles.badge} style={{ backgroundColor: '#FFD700', color: '#000' }}>Ouro</span>
            </div>
            <p>Score 85-100. Paciente exemplar — assiduo, confirma, vem todo mes.</p>
          </div>
          <div className={styles.card}>
            <div className={styles.cardTitle}>
              <span className={styles.badge} style={{ backgroundColor: '#C0C0C0', color: '#000' }}>Prata</span>
            </div>
            <p>Score 65-84. Bom paciente — frequente com poucas faltas.</p>
          </div>
          <div className={styles.card}>
            <div className={styles.cardTitle}>
              <span className={styles.badge} style={{ backgroundColor: '#CD7F32', color: '#fff' }}>Bronze</span>
            </div>
            <p>Score 40-64. Paciente irregular — vem de vez em quando.</p>
          </div>
        </div>
        <div className={styles.grid2}>
          <div className={styles.card}>
            <div className={styles.cardTitle}>
              <span className={styles.badge} style={{ backgroundColor: '#FF6B6B', color: '#fff' }}>Em Risco</span>
            </div>
            <p>Score 20-39. Paciente sumindo — poucas visitas recentes.</p>
          </div>
          <div className={styles.card}>
            <div className={styles.cardTitle}>
              <span className={styles.badge} style={{ backgroundColor: '#6C757D', color: '#fff' }}>Inativo</span>
            </div>
            <p>Score 0-19. Veio uma vez ou parou de vir.</p>
          </div>
        </div>

        <h3>Indicador de Tendencia</h3>
        <p>
          Compara a frequencia dos ultimos 3 meses com os 3 meses anteriores:
        </p>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Tendencia</th>
              <th>Condicao</th>
              <th>Indicador</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ color: '#28A745', fontWeight: 600 }}>Positiva</td>
              <td>Score subiu 5+ pontos</td>
              <td>Seta para cima verde</td>
            </tr>
            <tr>
              <td style={{ color: '#DC3545', fontWeight: 600 }}>Negativa</td>
              <td>Score caiu 5+ pontos</td>
              <td>Seta para baixo vermelha</td>
            </tr>
            <tr>
              <td style={{ color: '#FFC107', fontWeight: 600 }}>Estavel</td>
              <td>Variacao menor que 5 pontos</td>
              <td>Seta lateral amarela</td>
            </tr>
          </tbody>
        </table>

        <h3>Paginas e Funcionalidades</h3>
        <div className={styles.grid2}>
          <div className={styles.card}>
            <div className={styles.cardTitle}>Pagina Dedicada</div>
            <p>
              <span className={styles.route}>/admin/patient-scores</span>
            </p>
            <p>
              Cards de distribuicao por classificacao (clicaveis como filtro), tabela com sorting
              por score/nome/recencia, paginacao, e modal com breakdown detalhado ao clicar em um paciente.
            </p>
          </div>
          <div className={styles.card}>
            <div className={styles.cardTitle}>Na Listagem de Pacientes</div>
            <p>
              <span className={styles.route}>/admin/patients</span>
            </p>
            <p>
              Coluna "Score" na tabela existente exibindo badge com pontuacao, classificacao
              e icone de tendencia para cada paciente listado.
            </p>
          </div>
        </div>

        <h3>API Endpoints</h3>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Metodo</th>
              <th>Rota</th>
              <th>Descricao</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><span className={styles.badge} style={{ backgroundColor: '#28A745' }}>GET</span></td>
              <td><span className={styles.route}>/api/patient-scores</span></td>
              <td>Lista paginada com filtro por classificacao e sorting</td>
            </tr>
            <tr>
              <td><span className={styles.badge} style={{ backgroundColor: '#28A745' }}>GET</span></td>
              <td><span className={styles.route}>/api/patient-scores/:id</span></td>
              <td>Score detalhado de um paciente com breakdown</td>
            </tr>
            <tr>
              <td><span className={styles.badge} style={{ backgroundColor: '#F7941D' }}>POST</span></td>
              <td><span className={styles.route}>/api/patient-scores/summaries</span></td>
              <td>Batch de resumos para lista de IDs de pacientes</td>
            </tr>
            <tr>
              <td><span className={styles.badge} style={{ backgroundColor: '#28A745' }}>GET</span></td>
              <td><span className={styles.route}>/api/patient-scores/distribution</span></td>
              <td>Distribuicao de pacientes por classificacao</td>
            </tr>
          </tbody>
        </table>

        <div className={styles.infoBox}>
          <strong>Acesso:</strong> Roles Admin e Receptionist. O score e calculado em tempo real
          a partir dos dados de consultas — nao ha tabela de score persistida no banco.
        </div>
      </section>

      {/* 23. Importacao e Qualificacao de Leads */}
      <section className={styles.section} id="lead-imports">
        <h2>23. Importacao e Qualificacao de Leads</h2>
        <p>
          Pipeline multi-provedor para aquisicao de leads B2B na area de saude. O sistema adota uma
          arquitetura de dois estagios: <strong>staging</strong> (lead_imports) onde os dados brutos sao
          processados pela camada de inteligencia, e <strong>producao</strong> (leads) onde ficam os leads qualificados.
        </p>

        <h3>Arquitetura do Pipeline</h3>
        <div className={styles.stateMachine}>
          <div className={styles.stateFlow}>
            <span className={styles.stateNode} style={{ backgroundColor: '#6366F1' }}>Fontes de Dados</span>
            <span className={styles.stateArrow}>&rarr;</span>
            <span className={styles.stateNode} style={{ backgroundColor: '#F7941D' }}>lead_imports (staging)</span>
            <span className={styles.stateArrow}>&rarr;</span>
            <span className={styles.stateNode} style={{ backgroundColor: '#4A90D9' }}>Score + Dedup + LTV</span>
            <span className={styles.stateArrow}>&rarr;</span>
            <span className={styles.stateNode} style={{ backgroundColor: '#00A651' }}>leads (producao)</span>
          </div>
        </div>

        <h3>Provedores de Dados <span className={styles.route}>/admin/lead-providers</span></h3>
        <p>
          Cada fonte de leads e registrada como um provedor. A tela permite CRUD completo
          com nome, tipo, configuracao JSON e status ativo/inativo.
        </p>
        <table className={styles.table}>
          <thead>
            <tr><th>Tipo</th><th>Descricao</th><th>Status</th></tr>
          </thead>
          <tbody>
            <tr><td>APIFY_IMPORT</td><td>Importacao CSV de dados extraidos via Apify (Google Maps, Facebook, Instagram)</td><td>Implementado</td></tr>
            <tr><td>MANUAL</td><td>Entrada manual de leads</td><td>Implementado</td></tr>
            <tr><td>WEBSITE</td><td>Leads capturados pelo widget de campanha</td><td>Implementado</td></tr>
            <tr><td>META_ADS</td><td>Leads via webhook do Facebook/Instagram Ads</td><td>Planejado</td></tr>
            <tr><td>CNES</td><td>Cadastro Nacional de Estabelecimentos de Saude (API gratuita)</td><td>Planejado</td></tr>
            <tr><td>GOOGLE_PLACES</td><td>Google Places API (rating, reviews, telefone, website)</td><td>Planejado</td></tr>
            <tr><td>CNPJA</td><td>Consulta CNPJ via Receita Federal</td><td>Planejado</td></tr>
            <tr><td>SERPER</td><td>Busca em massa no Google via Serper.dev</td><td>Planejado</td></tr>
            <tr><td>APOLLO</td><td>Contatos B2B (nome, cargo, email) via Apollo.io</td><td>Planejado</td></tr>
            <tr><td>CFM</td><td>Verificacao de CRM medico via Conselho Federal de Medicina</td><td>Planejado</td></tr>
          </tbody>
        </table>

        <h3>Como Configurar um Provedor</h3>
        <ol>
          <li>Acesse <strong>/admin/lead-providers</strong> no menu lateral</li>
          <li>Clique em <strong>"Novo Provedor"</strong></li>
          <li>Preencha: Nome (ex: "Apify Google Maps SP"), Tipo (ex: APIFY_IMPORT), Config (JSON, pode ser {'{}'})</li>
          <li>Marque como ativo e salve</li>
        </ol>

        <h3>Importacao de Leads via CSV <span className={styles.route}>/admin/lead-imports</span></h3>
        <p>
          A tela de importacao possui tres secoes: upload de CSV, tabela de batches e tabela de imports.
        </p>
        <ol>
          <li>Selecione o arquivo CSV e o provedor cadastrado</li>
          <li>Clique em <strong>Upload</strong> — o sistema cria um batch e insere os registros na staging</li>
          <li>Clique em <strong>Processar</strong> em cada lead (ou no batch inteiro) para executar score + dedup</li>
          <li>Clique em <strong>Converter</strong> para promover o lead qualificado para a tabela leads</li>
        </ol>

        <h3>Formato do CSV</h3>
        <p>
          O CSV deve conter as seguintes colunas (um template pode ser baixado via GET /api/lead-imports/template):
        </p>
        <table className={styles.table}>
          <thead>
            <tr><th>Coluna</th><th>Obrigatorio</th><th>Descricao</th></tr>
          </thead>
          <tbody>
            <tr><td>business_name</td><td>Sim</td><td>Nome do estabelecimento</td></tr>
            <tr><td>phone</td><td>Sim</td><td>Telefone de contato</td></tr>
            <tr><td>email</td><td>Nao</td><td>Email de contato</td></tr>
            <tr><td>address</td><td>Nao</td><td>Endereco completo</td></tr>
            <tr><td>city</td><td>Nao</td><td>Cidade</td></tr>
            <tr><td>state</td><td>Nao</td><td>UF (2 letras)</td></tr>
            <tr><td>zip_code</td><td>Nao</td><td>CEP</td></tr>
            <tr><td>healthcare_segment</td><td>Nao</td><td>Segmento (Odontologia, Dermatologia, etc.)</td></tr>
            <tr><td>healthcare_specialty</td><td>Nao</td><td>Especialidade</td></tr>
            <tr><td>website</td><td>Nao</td><td>URL do site</td></tr>
            <tr><td>google_rating</td><td>Nao</td><td>Avaliacao Google (0-5)</td></tr>
            <tr><td>google_reviews_count</td><td>Nao</td><td>Numero de avaliacoes</td></tr>
          </tbody>
        </table>

        <h3>Score de Leads (0-100)</h3>
        <p>
          O score e calculado em 3 dimensoes, seguindo o mesmo padrao do PatientScoreCalculator:
        </p>
        <table className={styles.table}>
          <thead>
            <tr><th>Dimensao</th><th>Pontos</th><th>Criterios</th></tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Firmografica</strong></td>
              <td>0-40</td>
              <td>Especialidade alinhada ao ICP, porte do negocio, localizacao, tempo de operacao, decisor identificado</td>
            </tr>
            <tr>
              <td><strong>Presenca Digital</strong></td>
              <td>0-30</td>
              <td>Website, redes sociais, rating Google, anuncios pagos, multiplas unidades</td>
            </tr>
            <tr>
              <td><strong>Comportamental</strong></td>
              <td>0-30</td>
              <td>Resposta a contato, visita a precos, download de conteudo, participacao em webinar</td>
            </tr>
          </tbody>
        </table>

        <h3>Classificacao</h3>
        <div className={styles.stateMachine}>
          <div className={styles.stateFlow}>
            <span className={styles.stateNode} style={{ backgroundColor: '#DC2626' }}>HOT (70-100)</span>
            <span className={styles.stateNode} style={{ backgroundColor: '#F7941D' }}>WARM (50-69)</span>
            <span className={styles.stateNode} style={{ backgroundColor: '#4A90D9' }}>COOL (30-49)</span>
            <span className={styles.stateNode} style={{ backgroundColor: '#6B7280' }}>COLD (0-29)</span>
          </div>
        </div>

        <h3>LTV Estimado por Porte</h3>
        <table className={styles.table}>
          <thead>
            <tr><th>Porte</th><th>Descricao</th><th>LTV Estimado</th></tr>
          </thead>
          <tbody>
            <tr><td>SOLO</td><td>Profissional solo</td><td>R$ 2.880</td></tr>
            <tr><td>SMALL</td><td>Clinica pequena (2-5 profissionais)</td><td>R$ 9.000</td></tr>
            <tr><td>MEDIUM</td><td>Clinica media (6-20 profissionais)</td><td>R$ 30.240</td></tr>
            <tr><td>LARGE</td><td>Clinica grande / Hospital</td><td>R$ 93.600</td></tr>
          </tbody>
        </table>

        <h3>Deduplicacao</h3>
        <p>
          O sistema busca duplicatas em cadeia: telefone normalizado &rarr; website normalizado &rarr;
          nome + cidade. Tambem verifica contra leads existentes na tabela principal.
        </p>

        <h3>Status do Import</h3>
        <div className={styles.stateMachine}>
          <div className={styles.stateFlow}>
            <span className={styles.stateNode} style={{ backgroundColor: '#6366F1' }}>PENDING</span>
            <span className={styles.stateArrow}>&rarr;</span>
            <span className={styles.stateNode} style={{ backgroundColor: '#F7941D' }}>PROCESSING</span>
            <span className={styles.stateArrow}>&rarr;</span>
            <span className={styles.stateNode} style={{ backgroundColor: '#4A90D9' }}>QUALIFIED</span>
            <span className={styles.stateArrow}>&rarr;</span>
            <span className={styles.stateNode} style={{ backgroundColor: '#00A651' }}>CONVERTED</span>
          </div>
          <div className={styles.stateFlow}>
            <span className={styles.stateNode} style={{ backgroundColor: '#F7941D' }}>PROCESSING</span>
            <span className={styles.stateArrow}>&rarr;</span>
            <span className={styles.stateNode} style={{ backgroundColor: '#6B7280' }}>DUPLICATE / REJECTED</span>
          </div>
        </div>

        <h3>Endpoints da API</h3>
        <table className={styles.table}>
          <thead>
            <tr><th>Metodo</th><th>Endpoint</th><th>Descricao</th></tr>
          </thead>
          <tbody>
            <tr>
              <td><span className={styles.badge} style={{ backgroundColor: '#F7941D' }}>POST</span></td>
              <td><span className={styles.route}>/api/lead-imports/upload</span></td>
              <td>Upload CSV (multipart/form-data + providerId)</td>
            </tr>
            <tr>
              <td><span className={styles.badge} style={{ backgroundColor: '#28A745' }}>GET</span></td>
              <td><span className={styles.route}>/api/lead-imports</span></td>
              <td>Listar imports (paginado + filtros status/batch/classification)</td>
            </tr>
            <tr>
              <td><span className={styles.badge} style={{ backgroundColor: '#28A745' }}>GET</span></td>
              <td><span className={styles.route}>/api/lead-imports/:id</span></td>
              <td>Detalhes de um import</td>
            </tr>
            <tr>
              <td><span className={styles.badge} style={{ backgroundColor: '#F7941D' }}>POST</span></td>
              <td><span className={styles.route}>/api/lead-imports/:id/process</span></td>
              <td>Processar um import (score + dedup)</td>
            </tr>
            <tr>
              <td><span className={styles.badge} style={{ backgroundColor: '#F7941D' }}>POST</span></td>
              <td><span className={styles.route}>/api/lead-imports/:id/convert</span></td>
              <td>Converter import qualificado em lead</td>
            </tr>
            <tr>
              <td><span className={styles.badge} style={{ backgroundColor: '#F7941D' }}>POST</span></td>
              <td><span className={styles.route}>/api/lead-imports/batch/:batchId/process</span></td>
              <td>Processar todos os imports de um batch</td>
            </tr>
            <tr>
              <td><span className={styles.badge} style={{ backgroundColor: '#28A745' }}>GET</span></td>
              <td><span className={styles.route}>/api/lead-imports/template</span></td>
              <td>Download do template CSV</td>
            </tr>
            <tr>
              <td><span className={styles.badge} style={{ backgroundColor: '#28A745' }}>GET</span></td>
              <td><span className={styles.route}>/api/import-batches</span></td>
              <td>Listar batches (paginado + filtro status)</td>
            </tr>
            <tr>
              <td><span className={styles.badge} style={{ backgroundColor: '#28A745' }}>GET</span></td>
              <td><span className={styles.route}>/api/import-batches/:id</span></td>
              <td>Detalhes de um batch</td>
            </tr>
            <tr>
              <td><span className={styles.badge} style={{ backgroundColor: '#28A745' }}>GET</span></td>
              <td><span className={styles.route}>/api/lead-providers</span></td>
              <td>Listar provedores</td>
            </tr>
            <tr>
              <td><span className={styles.badge} style={{ backgroundColor: '#F7941D' }}>POST</span></td>
              <td><span className={styles.route}>/api/lead-providers</span></td>
              <td>Criar provedor</td>
            </tr>
            <tr>
              <td><span className={styles.badge} style={{ backgroundColor: '#4A90D9' }}>PUT</span></td>
              <td><span className={styles.route}>/api/lead-providers/:id</span></td>
              <td>Atualizar provedor</td>
            </tr>
          </tbody>
        </table>

        <div className={styles.infoBox}>
          <strong>Acesso:</strong> Todas as telas e endpoints de importacao sao restritos ao role Admin.
          A tela de Leads (/admin/leads) foi atualizada com colunas de Score e LTV, e filtro por Origem.
        </div>
      </section>

      {/* Back to top */}
      <footer className={styles.backTop}>
        <a href="#top">Voltar ao topo</a>
      </footer>
    </div>
  );
}
